import { snakeCase } from 'change-case';

import Base from 'app/views/base';

import tmpl from './template';

// Can't extend from components/list/item because of webpack+circular import issue
export default Base.extend({
  compiledTemplate: tmpl,

  initialize({ headings = [] }) {
    this.headings = headings;
    this.uid = parseInt(Math.random() * 100000, 10);
  },

  context() {
    return {
      headings: this.headings,
      model: this.model,
      computeHeadingId: this.computeHeadingId.bind(this),
      getTextFromHeading: this.getTextFromHeading,
    };
  },

  computeId(id) {
    return `${this.uid}-model-${id}`;
  },

  computeHeadingId(id, display) {
    return `${this.computeId(id)}-${snakeCase(display)}`;
  },

  getTextFromHeading(model, heading) {
    if (heading.text) {
      if (typeof heading.text === 'function') {
        return heading.text(model);
      }
      return heading.text;
    }

    const prop = heading.property;
    if (typeof model[prop] === 'function') {
      return model[prop]();
    }
    return model.get(prop);
  },
});



// WEBPACK FOOTER //
// ./app/components/list/sub_item/index.js